export default "__VITE_ASSET__338b8828__"